<template>

    <div>

        <sign-up1/>
    </div>

</template>

<style scoped>

</style>

<script>

import SignUp1 from "@/components/SignUp1";


export default {
  name: 'Signup',
  components:{
    SignUp1
  },
  props: {

  },
  data(){
    return{

    }
  },
  metaInfo() {
      return {
          title: "Register Step 1 | Pickafund",
          meta: [
              { name: 'description', content: 'Sign up for free to enjoy full access on Pickafund'},
              { property: 'og:title', content: "Register Step 1 | Pickafund"},
              
          ]
      }
  },
  watch: {
    '$store.state.auth.authenticated': function (data) {
      if(data) this.$router.push('/account');
    },
  }
}
</script>


